import { useRef, useState, type FormEvent } from 'react';
import { usarDialogo } from '../lib/dialogo.ts';
import { api } from '../lib/api.ts';

/** Igual ao mínimo que o servidor exige. Se um dia mudar lá, muda aqui. */
const MINIMO = 12;

export function TrocarSenha({ aoFechar }: { aoFechar: () => void }) {
  const [atual, setAtual] = useState('');
  const [nova, setNova] = useState('');
  const [repetida, setRepetida] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [pronto, setPronto] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const emVoo = useRef(false);

  usarDialogo(aoFechar);

  async function enviar(evento: FormEvent) {
    evento.preventDefault();
    if (emVoo.current) return;

    // A conferência da repetição é só aqui: o servidor não precisa saber que
    // a pessoa digitou duas vezes.
    if (nova !== repetida) return setErro('A nova senha e a repetição não são iguais.');
    if (nova.length < MINIMO) {
      return setErro(`A nova senha precisa ter pelo menos ${MINIMO} caracteres.`);
    }

    emVoo.current = true;
    setSalvando(true);
    setErro(null);
    try {
      await api.trocarSenha(atual, nova);
      setPronto(true);
    } catch (e) {
      setErro(e instanceof Error ? e.message : 'Não consegui trocar a senha.');
    } finally {
      emVoo.current = false;
      setSalvando(false);
    }
  }

  return (
    <div
      className="cortina"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) aoFechar();
      }}
    >
      <div className="dialogo" role="dialog" aria-modal="true" aria-label="Trocar a senha">
        <h2 className="titulo-secao">Trocar a senha</h2>

        {pronto ? (
          <>
            <p className="aviso-bom">
              Senha trocada. Se você estava conectado em outro aparelho, aquela
              sessão foi encerrada.
            </p>
            <div className="dialogo-acoes">
              <button type="button" className="botao-primario" onClick={aoFechar}>
                Fechar
              </button>
            </div>
          </>
        ) : (
          <form onSubmit={enviar} noValidate>
            {erro && <p className="erro">{erro}</p>}

            <div className="campo">
              <label htmlFor="atual" className="rotulo">
                Senha atual
              </label>
              <input
                id="atual"
                type="password"
                autoComplete="current-password"
                value={atual}
                onChange={(e) => setAtual(e.target.value)}
                autoFocus
              />
            </div>

            <div className="campo">
              <label htmlFor="nova" className="rotulo">
                Nova senha
              </label>
              <input
                id="nova"
                type="password"
                autoComplete="new-password"
                value={nova}
                onChange={(e) => setNova(e.target.value)}
              />
              <p className="ajuda">
                Pelo menos {MINIMO} caracteres. Uma frase que só você saiba vale mais
                que letra trocada por símbolo.
              </p>
            </div>

            <div className="campo">
              <label htmlFor="repetida" className="rotulo">
                Repita a nova senha
              </label>
              <input
                id="repetida"
                type="password"
                autoComplete="new-password"
                value={repetida}
                onChange={(e) => setRepetida(e.target.value)}
              />
            </div>

            <div className="dialogo-acoes">
              <button type="button" className="botao-secundario" onClick={aoFechar}>
                Cancelar
              </button>
              <button
                type="submit"
                className="botao-primario"
                disabled={salvando || !atual || !nova || !repetida}
              >
                {salvando ? 'Trocando…' : 'Trocar senha'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
